<template>
  <div class="login">
	<!-- 顶部导航 -->
	<div class="login-top">
		<div class="logo">
			<div class="logo-badge">
				<img src="/logo.png" alt="Logo" class="logo-img">
			</div>
			<div class="logo-text">
				<div class="logo-name">青少年人工智能高水平创新人才培养 课程平台</div>
				<div class="logo-slogan">Youth AI High-Level Innovative Talent Training</div>
			</div>
		</div>
		<div class="btns">
			<div class="btn-pill-outline" @click="toRegister">学生注册</div>
			<div class="btn-grad btn-grad-sm" @click="toTeacherRegister">教师入驻</div>
		</div>
	</div>
	<!-- 主体区域 -->
	<div class="login-center">
		<!-- 左侧：品牌宣传区 -->
		<div class="login-hero">
			<!-- 装饰形状 -->
			<div class="deco deco-1"></div>
			<div class="deco deco-2"></div>
			<div class="deco deco-3"></div>
			<div class="deco-ring"></div>

			<div class="hero-content">
				<div class="hero-tag"><i class="el-icon-magic-stick"></i>青少年人工智能高水平创新人才培养 课程平台</div>
				<div class="hero-title">
					让每个孩子<br>都能<span class="hero-highlight">和 AI 一起成长</span>
				</div>
				<div class="hero-desc">Scratch 图形化编程 · Python 人工智能 · C++ 算法竞赛<br>跟随老师的班级课程，一步一步成为 AI 小达人！</div>
				<div class="hero-points">
					<div class="hero-point"><i class="el-icon-video-play"></i>趣味视频课程</div>
					<div class="hero-point"><i class="el-icon-user"></i>名师在线指导</div>
					<div class="hero-point"><i class="el-icon-trophy"></i>编程挑战闯关</div>
				</div>
				<!-- 小机器人插画 -->
				<svg class="robot" width="150" height="160" viewBox="0 0 150 160" fill="none">
					<ellipse cx="75" cy="150" rx="46" ry="7" fill="rgba(0,0,0,0.18)"/>
					<line x1="75" y1="12" x2="75" y2="30" stroke="#FFE066" stroke-width="4" stroke-linecap="round"/>
					<circle cx="75" cy="10" r="6" fill="#FFE066"/>
					<rect x="40" y="28" width="70" height="52" rx="22" fill="#FFFFFF"/>
					<rect x="50" y="38" width="50" height="26" rx="13" fill="#2B3A67"/>
					<circle cx="65" cy="51" r="5" fill="#4DE1FF"/>
					<circle cx="85" cy="51" r="5" fill="#4DE1FF"/>
					<path d="M70 58 Q75 62 80 58" stroke="#4DE1FF" stroke-width="2.5" stroke-linecap="round" fill="none"/>
					<rect x="26" y="44" width="10" height="18" rx="5" fill="#C9D2FF"/>
					<rect x="114" y="44" width="10" height="18" rx="5" fill="#C9D2FF"/>
					<rect x="48" y="88" width="54" height="44" rx="16" fill="#FFFFFF"/>
					<circle cx="75" cy="108" r="9" fill="none" stroke="#8A7BFF" stroke-width="3"/>
					<circle cx="75" cy="108" r="3.5" fill="#FF9F43"/>
					<rect x="30" y="92" width="14" height="26" rx="7" fill="#C9D2FF"/>
					<rect x="106" y="92" width="14" height="26" rx="7" fill="#C9D2FF"/>
					<rect x="56" y="132" width="15" height="14" rx="6" fill="#C9D2FF"/>
					<rect x="79" y="132" width="15" height="14" rx="6" fill="#C9D2FF"/>
				</svg>
			</div>
		</div>
		<!-- 右侧：登录表单卡片 -->
		<div class="login-form">
			<div class="form-card">
				<div class="form-head">
					<div class="form-title">欢迎回来</div>
					<div class="form-sub">登录账号，继续你的 AI 学习之旅</div>
				</div>
				<el-form :model="userInfo" :rules="rules" ref="ruleForm" class="login-form-el">
					<el-form-item prop="username">
						<el-input v-model="userInfo.username" placeholder="请输入用户账号" prefix-icon="el-icon-user" size="large"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input type="password" v-model="userInfo.password" placeholder="请输入用户密码" prefix-icon="el-icon-lock" size="large"></el-input>
					</el-form-item>
				</el-form>
				<div class="btn-grad login-btn" @click="toLogin()">登 录</div>
				<div class="form-foot">
					<span>还没有账号？</span>
					<span class="link" @click="toRegister">立即注册</span>
				</div>
			</div>
		</div>
	</div>
	<bottomPage></bottomPage>
  </div>
</template>

<script>
  import {login,getUser,getFirstLoginStatus} from '../../api/api'
  import bottomPage from "../../components/bottom/login-bottom"
  export default {
	data() {
	  return{
		userInfo: {
			username: "",
			password: ""
		},
		rules: {
          username: [
            { required: true, message: '请输入用户账号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入用户密码', trigger: 'blur' }
          ],
        }
	  }
	},
	components: {
        bottomPage
	},
	methods: {
		toRegister() {
			this.$router.push("/register")
		},
		toTeacherRegister() {
			this.$router.push("/teacherRegister")
		},
		toLogin() {
			this.$refs["ruleForm"].validate((valid) => {
				if (valid) {
					var params = {
						username: this.userInfo.username,
						password: this.userInfo.password
					}
					login(params).then(res => {
						if(res.code == 1000) {
							this.$message({
								message: '登陆成功',
								type: 'success'
							});
							var that = this
							var token = res.data.token
							window.localStorage.setItem("user_token",token)
							this.getUserInfo()
							// 首次登录的学生需要先选择学校/班级
							getFirstLoginStatus().then(statusRes => {
								if(statusRes.code == 1000 && statusRes.data == 1) {
									that.$router.push("/chooseClass")
								} else {
									setTimeout(function() {
										that.$router.push("/")
									},500)
								}
							}).catch(() => {
								setTimeout(function() {
									that.$router.push("/")
								},500)
							})
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					return false;
				}
			});
		},
		getUserInfo() {
            getUser().then(res => {
                if(res.code == 1000) {
					window.localStorage.setItem("user_info",JSON.stringify(res.data))
                }
            })
        },
	},
	created() {

	},
	mounted() {

	}
 }
</script>

<style scoped>
  .login {
	  width: 100%;
	  min-height: 100%;
	  display: flex;
	  flex-direction: column;
	  background: var(--bg-page);
  }
  /* ===== 顶部导航 ===== */
  .login-top {
	  height: 84px;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  padding: 0 60px;
	  flex-shrink: 0;
  }
  .logo {
	  display: flex;
	  align-items: center;
  }
  .logo-badge {
	  width: 48px;
	  height: 48px;
	  border-radius: 14px;
	  background: #FFFFFF;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  box-shadow: 0 6px 16px rgba(91, 108, 255, 0.35);
	  overflow: hidden;
  }
  .logo-img {
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	  border-radius: 14px;
  }
  .logo-text {
	  margin-left: 12px;
  }
  .logo-name {
	  font-size: 20px;
	  font-weight: 700;
	  background: var(--grad-primary);
	  -webkit-background-clip: text;
	  background-clip: text;
	  color: transparent;
	  letter-spacing: 1px;
  }
  .logo-slogan {
	  margin-top: 2px;
	  font-size: 12px;
	  color: var(--text-sub);
	  letter-spacing: 0.5px;
  }
  .btns {
	  display: flex;
	  align-items: center;
	  gap: 16px;
  }
  .btn-grad-sm {
	  height: 40px;
	  padding: 0 26px;
	  font-size: 15px;
	  letter-spacing: 2px;
  }
  /* ===== 主体区域 ===== */
  .login-center {
	  flex: 1;
	  margin: 10px 60px 40px;
	  border-radius: var(--radius-lg);
	  overflow: hidden;
	  display: flex;
	  box-shadow: var(--shadow-card);
  }
  /* 左侧宣传区 */
  .login-hero {
	  position: relative;
	  width: 56%;
	  background: var(--grad-hero);
	  display: flex;
	  align-items: center;
	  overflow: hidden;
  }
  .hero-content {
	  position: relative;
	  z-index: 2;
	  padding: 50px 70px;
	  color: #FFFFFF;
  }
  .hero-tag {
	  display: inline-flex;
	  align-items: center;
	  gap: 6px;
	  padding: 7px 18px;
	  border-radius: 999px;
	  background: rgba(255, 255, 255, 0.16);
	  border: 1px solid rgba(255, 255, 255, 0.30);
	  font-size: 13px;
	  letter-spacing: 1px;
	  backdrop-filter: blur(4px);
  }
  .hero-title {
	  margin-top: 26px;
	  font-size: 46px;
	  font-weight: 700;
	  line-height: 1.3;
	  letter-spacing: 2px;
  }
  .hero-highlight {
	  background: linear-gradient(135deg, #FFE066 0%, #FFB020 100%);
	  -webkit-background-clip: text;
	  background-clip: text;
	  color: transparent;
  }
  .hero-desc {
	  margin-top: 20px;
	  font-size: 15px;
	  line-height: 1.9;
	  color: rgba(255, 255, 255, 0.85);
	  letter-spacing: 1px;
  }
  .hero-points {
	  margin-top: 30px;
	  display: flex;
	  gap: 14px;
  }
  .hero-point {
	  display: flex;
	  align-items: center;
	  gap: 7px;
	  padding: 10px 18px;
	  border-radius: 999px;
	  background: rgba(255, 255, 255, 0.14);
	  border: 1px solid rgba(255, 255, 255, 0.22);
	  font-size: 14px;
	  letter-spacing: 1px;
  }
  .hero-point i {
	  color: #FFE066;
	  font-size: 16px;
  }
  .robot {
	  margin-top: 36px;
	  animation: float 3.2s ease-in-out infinite;
  }
  /* 装饰元素 */
  .deco {
	  position: absolute;
	  border-radius: 50%;
	  z-index: 1;
  }
  .deco-1 {
	  width: 340px;
	  height: 340px;
	  right: -90px;
	  top: -90px;
	  background: radial-gradient(circle, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-2 {
	  width: 260px;
	  height: 260px;
	  left: -70px;
	  bottom: -70px;
	  background: radial-gradient(circle, rgba(255, 224, 102, 0.22) 0%, rgba(255,255,255,0) 70%);
  }
  .deco-3 {
	  width: 110px;
	  height: 110px;
	  right: 90px;
	  bottom: 60px;
	  border-radius: 32px;
	  background: rgba(255, 255, 255, 0.08);
	  transform: rotate(18deg);
  }
  .deco-ring {
	  position: absolute;
	  width: 140px;
	  height: 140px;
	  right: 40px;
	  top: 70px;
	  border: 14px solid rgba(255, 255, 255, 0.10);
	  border-radius: 50%;
	  z-index: 1;
  }
  /* 右侧表单区 */
  .login-form {
	  width: 44%;
	  background: #FFFFFF;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  position: relative;
  }
  .login-form::before {
	  content: '';
	  position: absolute;
	  width: 180px;
	  height: 180px;
	  right: -50px;
	  top: -50px;
	  border-radius: 50%;
	  background: radial-gradient(circle, rgba(91, 108, 255, 0.08) 0%, rgba(255,255,255,0) 70%);
  }
  .form-card {
	  width: 68%;
	  position: relative;
	  z-index: 2;
  }
  .form-title {
	  font-size: 30px;
	  font-weight: 700;
	  color: var(--text-main);
	  letter-spacing: 1px;
  }
  .form-sub {
	  margin-top: 10px;
	  margin-bottom: 34px;
	  font-size: 14px;
	  color: var(--text-sub);
	  letter-spacing: 1px;
  }
  .login-form-el >>> .el-input__inner {
	  height: 48px;
	  line-height: 48px;
	  border-radius: 12px;
	  background: #F7F8FE;
	  border-color: #EDEFF9;
  }
  .login-form-el >>> .el-input__inner:focus {
	  background: #FFFFFF;
	  border-color: var(--primary);
  }
  .login-form-el >>> .el-form-item {
	  margin-bottom: 22px;
  }
  .login-btn {
	  width: 100%;
	  margin-top: 6px;
  }
  .form-foot {
	  margin-top: 22px;
	  text-align: center;
	  font-size: 14px;
	  color: var(--text-sub);
  }
  .form-foot .link {
	  color: var(--primary);
	  font-weight: 600;
	  cursor: pointer;
	  margin-left: 6px;
  }
  .form-foot .link:hover {
	  text-decoration: underline;
  }
  /* ===== 动画 ===== */
  @keyframes float {
	  0%, 100% { transform: translateY(0); }
	  50% { transform: translateY(-12px); }
  }
</style>
